import { styled } from "styled-components";

export const HomeContentsTitleWrapper = styled.div`
  border-bottom: 1px solid #233e99;
  margin-bottom: 24px;
  h4 {
    padding: 16px 0;
    font-size: 32px;
    line-height: 1.4;
    font-weight: bold;
    color: #233e99;
  }
  @media all and (max-width: 768px) {
    margin-bottom: 3.385vw;
    h4 {
      padding: 2.344vw 0;
      font-size: 5.208vw;
    }
  }
`;
